import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Pause = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21ZM16 8.5C16.8284 8.5 17.5 9.17157 17.5 10V32C17.5 32.8284 16.8284 33.5 16 33.5C15.1716 33.5 14.5 32.8284 14.5 32V10C14.5 9.17157 15.1716 8.5 16 8.5ZM27.5 10C27.5 9.17157 26.8284 8.5 26 8.5C25.1716 8.5 24.5 9.17157 24.5 10V32C24.5 32.8284 25.1716 33.5 26 33.5C26.8284 33.5 27.5 32.8284 27.5 32V10Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
